module.exports = __webpack_public_path__ + "static/media/down-arrow.f5b0e7c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/candidate/assets/down-arrow.svg
// module id = 1634
// module chunks = 0